import { render, staticRenderFns } from "./xinjiangUnionPayUnionConfigure.vue?vue&type=template&id=5c6dbdb0&scoped=true&"
import script from "./xinjiangUnionPayUnionConfigure.vue?vue&type=script&lang=js&"
export * from "./xinjiangUnionPayUnionConfigure.vue?vue&type=script&lang=js&"
import style0 from "./xinjiangUnionPayUnionConfigure.vue?vue&type=style&index=0&id=5c6dbdb0&scoped=true&lang=css&"
import style1 from "./xinjiangUnionPayUnionConfigure.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6dbdb0",
  null
  
)

export default component.exports